import { Avatar } from '@uag/react-core';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { useRequestContext } from './RequestProvider';

export const RequestHeader = ({ children }: PropsWithChildren) => {
    const { t } = useTranslation();
    const { request } = useRequestContext();
    const img = request.dokaOnboardingResponsible?.model.profilePictureUri;
    const requestManagerName = request.dokaOnboardingResponsible?.model.displayName;
    return (
        <div className="gap-base border-border-default pb-base flex flex-row border-b">
            <div className="flex grow flex-col gap-1">
                <div className="flex gap-1">
                    <div>{request.companyData.companyName}</div>
                    <div>
                        {request.companyData.customerIdentifier && ` · ${request.companyData.customerIdentifier}`}
                    </div>
                </div>
                <div className="flex gap-2">
                    <Avatar size="xs" src={img} />
                    <div className="text-text-light text-base">
                        {t('requestHeaderDescription', {
                            manager: requestManagerName,
                        })}
                    </div>
                </div>
            </div>
            <div>{children}</div>
        </div>
    );
};
